import React from "react";
import ReasonSummaries from "./ReasonSummaries";

function Reason() {
  return (
    <div className="w-full max-w-[1100px] md:w-[100%] mx-auto mb-0 md:mb-20" id="service">
      <h2 className="mb-2 md:mb-4">Beaver Deliveryが選ばれる理由</h2>
      <ReasonSummaries />
    </div>
  );
}

export default Reason;
